import React, { Component } from 'react';
// import { Link } from 'react-router';
// import Select2 from 'react-select2-wrapper';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getCasesByDate } from '../utils/db';
import withSelectCaseDate from '../common/withSelectCaseDate';
import { sortData } from '../common/globals';
import Bugsnag from '../helpers/bugsnag';

class DayFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectHospitals: [],
      selectedRefs: [],
      selectedTypes: [],
      selectSurgeon: [],
      ProcedureType: [],
      Side: [],
      PatientID: [],
      repData: [],
      hospitals: [],
      surgeons: [],
      types: [],
      procedures: [],
      side: [],
      patients: [],
      clearData: {},
      selectedAcm: false,
      isAcm: false,
      submitTypes: [
        {
          name: 'NOT SUBMITTED'
        }, {
          name: 'SUBMITTED'
        }
      ],
      selectSubmitted: [],
      MRN: [],
      mrns: [],
    };
  }

  _onSelectAcm = async (value) => {
    try {
      if (value === true) {
        this.setState({ isAcm: true, selectedAcm: true }, () => {
          this._onFilter({ selectedAcm: ['ACM'] });
        });
      } else {
        this.setState({ isAcm: false, selectedAcm: false }, () => {
          this._onFilter({ selectedAcm: [] });
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectRep = async (id) => {
    try {
      let { selectedRefs } = this.state;
      if (selectedRefs.indexOf(id) > -1) {
        selectedRefs = selectedRefs.filter((val) => val !== id);
        this._onFilter({ selectedRefs });
        this.setState({ selectedRefs });
      } else {
        selectedRefs.push(id);
        this._onFilter({ selectedRefs });
      }
      this.setState({ selectedRefs });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectHospital = async (id) => {
    try {
      let { selectHospitals } = this.state;
      if (selectHospitals.indexOf(id) > -1) {
        selectHospitals = selectHospitals.filter((val) => val !== id);
        this._onFilter({ selectHospitals });
        this.setState({ selectHospitals });
      } else {
        selectHospitals.push(id);
        this._onFilter({ selectHospitals });
      }
      this.setState({ selectHospitals });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectType = async (id) => {
    try {
      let { selectedTypes } = this.state;
      if (selectedTypes.indexOf(id) > -1) {
        selectedTypes = selectedTypes.filter((val) => val !== id);
        this._onFilter({ selectedTypes });
        this.setState({ selectedTypes });
      } else {
        selectedTypes.push(id);
        this._onFilter({ selectedTypes });
      }
      this.setState({ selectedTypes });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectProcedures = async (id) => {
    try {
      let { ProcedureType } = this.state;
      if (ProcedureType.indexOf(id) > -1) {
        ProcedureType = ProcedureType.filter((val) => val !== id);
        this._onFilter({ ProcedureType });
        this.setState({ ProcedureType });
      } else {
        ProcedureType.push(id);
        this._onFilter({ ProcedureType });
      }
      await this.setState({ ProcedureType });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectSurgeon = async (id) => {
    try {
      let { selectSurgeon } = this.state;
      if (selectSurgeon.indexOf(id) > -1) {
        selectSurgeon = selectSurgeon.filter((val) => val !== id);
        this._onFilter({ selectSurgeon });
        this.setState({ selectSurgeon });
      } else {
        selectSurgeon.push(id);
        this._onFilter({ selectSurgeon });
      }
      await this.setState({ selectSurgeon });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectSide = async (id) => {
    try {
      let { Side } = this.state;
      if (Side.indexOf(id) > -1) {
        Side = Side.filter((val) => val !== id);
        this._onFilter({ Side });
        this.setState({ Side });
      } else {
        Side.push(id);
        this._onFilter({ Side });
      }
      await this.setState({ Side });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectPatient = async (id) => {
    try {
      let { PatientID } = this.state;
      if (PatientID.indexOf(id) > -1) {
        PatientID = PatientID.filter((val) => val !== id);
        this._onFilter({ PatientID });
        this.setState({ PatientID });
      } else {
        PatientID.push(id);
        this._onFilter({ PatientID });
      }
      await this.setState({ PatientID });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectMrn = async (id) => {
    try {
      let { MRN } = this.state;
      if (MRN.indexOf(id) > -1) {
        MRN = MRN.filter((val) => val !== id);
        this._onFilter({ MRN });
        this.setState({ MRN });
      } else {
        MRN.push(id);
        this._onFilter({ MRN });
      }
      await this.setState({ MRN });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onSelectSubmitted = async (id) => {
    try {
      let { selectSubmitted } = this.state;
      if (selectSubmitted.indexOf(id) > -1) {
        selectSubmitted = selectSubmitted.filter((val) => val !== id);
        this._onFilter({ selectSubmitted });
        this.setState({ selectSubmitted });
      } else {
        selectSubmitted.push(id);
        this._onFilter({ selectSubmitted });
      }

      await this.setState({ selectSubmitted });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onFilter = (data) => {
    try {
      const { onFilter, previousData } = this.props;
      onFilter(Object.assign(previousData, data));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setAcmCaseFlag = async () => {
    try {
      const { selectCaseDate } = this.props;
      const acmData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));
      const acmPromiseAll = acmData.map(
        (data) => new Promise((resolve) => {
          if (data.ACMCaseID !== null) {
            this.setState({ getAcmFlag: true });
          }
          resolve(true);
        })
      );
      await Promise.all(acmPromiseAll);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setHospitalData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let hospitals = [];
      const hospitalData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const hospitalPromiseAll = hospitalData.map(
        (data) => new Promise((resolve) => {
          if (data.CustomerName !== null) {
            hospitals.push({ CustomerName: data.CustomerName, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(hospitalPromiseAll);
      hospitals = [...new Map(hospitals.map((item) => [item.CustomerName, item])).values()];
      const sortHospitals = sortData(hospitals, 'CustomerName');
      this.setState({ hospitals: sortHospitals });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setSurgeonData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let surgeons = [];
      const surgeonsData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const surgeonsPromiseAll = surgeonsData.map(
        (data) => new Promise((resolve) => {
          if (data.SurgeonName !== null) {
            surgeons.push({ SurgeonName: data.SurgeonName, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(surgeonsPromiseAll);
      surgeons = [...new Map(surgeons.map((item) => [item.SurgeonName, item])).values()];
      const sortSurgeons = sortData(surgeons, 'SurgeonName');
      this.setState({ surgeons: sortSurgeons });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setRepData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let repData = [];
      const coverRepData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const repsPromiseAll = coverRepData.map(
        (data) => new Promise((resolve) => {
          if (data.CoverRep !== null && data.CoverRep !== 'NONE') {
            repData.push({ SalesRepName: data.CoverRep, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(repsPromiseAll);
      repData = [...new Map(repData.map((item) => [item.SalesRepName, item])).values()];
      const sortRepData = sortData(repData, 'SalesRepName');
      this.setState({ repData: sortRepData });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setCaseTypeData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let types = [];
      const typeData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const typePromiseAll = typeData.map(
        (data) => new Promise((resolve) => {
          if (data.AltCaseType !== null) {
            types.push({ AltCaseType: data.AltCaseType, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(typePromiseAll);
      types = [...new Map(types.map((item) => [item.AltCaseType, item])).values()];
      const sortCaseTypes = sortData(types, 'AltCaseType');
      this.setState({ types: sortCaseTypes });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setProcedureTypeData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let procedures = [];
      const procedureTypeData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const procedureTypePromiseAll = procedureTypeData.map(
        (data) => new Promise((resolve) => {
          if (data.ProcedureType !== null) {
            procedures.push({ OptionName: data.ProcedureType, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(procedureTypePromiseAll);
      procedures = [...new Map(procedures.map((item) => [item.OptionName, item])).values()];
      const sortProcedureType = sortData(procedures, 'OptionName');
      this.setState({ procedures: sortProcedureType });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setSideData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let side = [];
      const sideData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const sidePromiseAll = sideData.map(
        (data) => new Promise((resolve) => {
          if (data.Side !== null) {
            side.push({ Side: data.Side, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(sidePromiseAll);
      side = [...new Map(side.map((item) => [item.Side, item])).values()];
      const sortSide = sortData(side, 'Side');
      this.setState({ side: sortSide });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setPatientData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let patients = [];
      const patientData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const patientPromiseAll = patientData.map(
        (data) => new Promise((resolve) => {
          if (data.PatientID !== null) {
            patients.push({ PatientID: (data.PatientID !== '' || data.PatientID !== null) && data.PatientID, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(patientPromiseAll);
      patients = [...new Map(patients.map((item) => [item.PatientID, item])).values()];
      const sortPatients = sortData(patients, 'PatientID');
      this.setState({ patients: sortPatients });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setMRNData = async () => {
    try {
      const { selectCaseDate } = this.props;
      let mrns = [];
      const mrnData = await getCasesByDate(moment(selectCaseDate).format('YYYY-MM-DD'));

      const mrnPromiseAll = mrnData.map(
        (data) => new Promise((resolve) => {
          if (data.MRN !== null) {
            mrns.push({ MRN: (data.MRN !== '' || data.MRN !== null) && data.MRN, id: data.id });
          }
          resolve(true);
        })
      );
      await Promise.all(mrnPromiseAll);
      mrns = [...new Map(mrns.map((item) => [item.MRN, item])).values()];
      const sortMrns = sortData(mrns, 'MRN');
      this.setState({ mrns: sortMrns });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setDayFilterData = async () => {
    try {
      const { selectedFilter } = this.props;

      await this._setAcmCaseFlag();
      await this._setHospitalData();
      await this._setSurgeonData();
      await this._setRepData();
      await this._setCaseTypeData();
      await this._setProcedureTypeData();
      await this._setSideData();
      await this._setPatientData();
      await this._setMRNData();
      this.setState({
        isAcm: !!(selectedFilter.hasOwnProperty('selectedAcm')),
        selectedTypes: (selectedFilter.hasOwnProperty('selectedTypes'))
          ? selectedFilter.selectedTypes
          : [],
        selectHospitals: (selectedFilter.hasOwnProperty('selectHospitals'))
          ? selectedFilter.selectHospitals
          : [],
        selectedRefs: (selectedFilter.hasOwnProperty('selectedRefs'))
          ? selectedFilter.selectedRefs
          : [],
        ProcedureType: (selectedFilter.hasOwnProperty('ProcedureType'))
          ? selectedFilter.ProcedureType
          : [],
        selectSurgeon: (selectedFilter.hasOwnProperty('selectSurgeon'))
          ? selectedFilter.selectSurgeon
          : [],
        PatientID: (selectedFilter.hasOwnProperty('PatientID'))
          ? selectedFilter.PatientID
          : [],
        MRN: (selectedFilter.hasOwnProperty('MRN'))
          ? selectedFilter.MRN
          : [],
        Side: (selectedFilter.hasOwnProperty('Side'))
          ? selectedFilter.Side
          : [],
        selectSubmitted: (selectedFilter.hasOwnProperty('selectSubmitted'))
          ? selectedFilter.selectSubmitted
          : []
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._setDayFilterData();
      // this.setClearFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      selectHospitals,
      selectSurgeon,
      selectedTypes,
      repData,
      ProcedureType,
      Side,
      PatientID,
      isAcm,
      getAcmFlag,
      selectedRefs,
      hospitals,
      surgeons,
      types,
      procedures,
      side,
      patients,
      submitTypes,
      selectSubmitted,
      MRN,
      mrns,
    } = this.state;

    return (
      <section className="filter-section resizer-class">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {
                getAcmFlag
                && (
                  <div className="day-filter">
                    <span className=""> ACM</span>
                    <div className="topping day-filter-item">
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          className="custom-check-bok"
                          value={isAcm}
                          checked={isAcm}
                          onChange={() => this._onSelectAcm(!isAcm)}
                        />
                        <span className="me-2" />
                        ACM
                      </label>
                    </div>
                  </div>
                )
              }

              {
                getAcmFlag
                && (<hr />)
              }

              <div className="day-filter">
                <span className=""> Rep</span>
                {
                  repData.map((rep, key) => (
                    <div className="topping day-filter-item" key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          className="custom-check-bok"
                          value={selectedRefs}
                          checked={selectedRefs.indexOf(rep.SalesRepName) > -1}
                          onChange={() => this._onSelectRep(rep.SalesRepName)}
                        />
                        <span className="me-2" />
                        {rep.SalesRepName}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Hospital</span>
                {
                  hospitals.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={selectHospitals}
                          checked={selectHospitals.indexOf(value.CustomerName) > -1}
                          onChange={() => this._onSelectHospital(value.CustomerName)}
                        />
                        <span className="me-2" />
                        {value.CustomerName}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Surgeon</span>
                {
                  surgeons.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={selectSurgeon}
                          checked={selectSurgeon.indexOf(value.SurgeonName) > -1}
                          onChange={() => this._onSelectSurgeon(value.SurgeonName)}
                        />
                        <span className="me-2" />
                        {value.SurgeonName}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Type</span>
                {
                  types.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={selectedTypes}
                          checked={selectedTypes.indexOf(value.AltCaseType) > -1}
                          onChange={() => this._onSelectType(value.AltCaseType)}
                        />
                        <span className="me-2" />
                        {value.AltCaseType}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Procedure</span>
                {
                  procedures.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={ProcedureType}
                          checked={ProcedureType.indexOf(value.OptionName) > -1}
                          onChange={() => this._onSelectProcedures(value.OptionName)}
                        />
                        <span className="me-2" />
                        {value.OptionName}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Side</span>
                {
                  side.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={Side}
                          checked={Side.indexOf(value.Side) > -1}
                          onChange={() => this._onSelectSide(value.Side)}
                        />
                        <span className="me-2" />
                        {value.Side}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Patient</span>
                {
                  patients.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={PatientID}
                          checked={PatientID.indexOf(value.PatientID) > -1}
                          onChange={() => this._onSelectPatient(value.PatientID)}
                        />
                        <span className="me-2" />
                        {value.PatientID}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> MRN</span>
                {
                  mrns.map((value, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={MRN}
                          checked={MRN.indexOf(value.MRN) > -1}
                          onChange={() => this._onSelectMrn(value.MRN)}
                        />
                        <span className="me-2" />
                        {value.MRN}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr />

              <div className="day-filter">
                <span className=""> Submitted</span>
                {
                  submitTypes.map((item, key) => (
                    <div className="topping day-filter-item " key={key}>
                      <label className="cursor-pointer mt-2">
                        <input
                          type="checkbox" id="topping"
                          name="topping"
                          value={item.name}
                          checked={selectSubmitted.indexOf(item.name) > -1}
                          onChange={() => this._onSelectSubmitted(item.name)}
                        />
                        <span className="me-2" />
                        {item.name}
                      </label>
                    </div>
                  ))
                }
              </div>

              <hr style={{ backgroundColor: 'darkred', margin: '4px' }} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

DayFilter.propTypes = {
  onFilter: PropTypes.func.isRequired,
  previousData: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedFilter: PropTypes.objectOf(PropTypes.any).isRequired,
  selectCaseDate: PropTypes.objectOf(PropTypes.any).isRequired
};

export default withSelectCaseDate(
  DayFilter
);
